import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Trophy } from "lucide-react";
import { fetchLeaderboard } from "../lib/api";
import { useProgress } from "../context/ProgressContext";

export default function Leaderboard() {
  const { sessionId, progress } = useProgress();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { entries } = await fetchLeaderboard();
        setEntries(entries || []);
      } catch (e) {
        console.warn(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-6 md:px-10 py-10 md:py-16">
      <Link to="/" className="inline-flex items-center gap-2 font-mono-code text-xs uppercase tracking-widest text-muted-foreground hover:text-primary mb-6">
        <ArrowLeft className="w-4 h-4" /> back
      </Link>
      <h1 className="font-serif-display text-5xl md:text-6xl mb-2">Leaderboard</h1>
      <p className="text-muted-foreground mb-10">Top prompt engineers by XP earned.</p>

      <div className="border border-border" data-testid="leaderboard-table">
        <div className="grid grid-cols-12 gap-4 px-6 py-3 border-b border-border bg-surface font-mono-code text-[10px] uppercase tracking-widest text-muted-foreground">
          <div className="col-span-1">#</div>
          <div className="col-span-7">Learner</div>
          <div className="col-span-2 text-right">Badges</div>
          <div className="col-span-2 text-right">XP</div>
        </div>
        {loading ? (
          <div className="p-6 text-muted-foreground">Loading…</div>
        ) : entries.length === 0 ? (
          <div className="p-6 text-muted-foreground">Be the first — start a module!</div>
        ) : (
          entries.map((e, i) => {
            const isMe = e.session_id === sessionId;
            return (
              <div
                key={e.session_id}
                className={
                  "grid grid-cols-12 gap-4 px-6 py-4 border-b border-border last:border-b-0 " +
                  (isMe ? "bg-primary/5" : "")
                }
              >
                <div className="col-span-1 font-serif-display text-xl">{i + 1}</div>
                <div className="col-span-7 flex items-center gap-3">
                  {i === 0 && <Trophy className="w-4 h-4 text-primary" />}
                  <span className="font-mono-code text-sm truncate">
                    {isMe ? "you" : e.session_id.slice(0, 12) + "…"}
                  </span>
                </div>
                <div className="col-span-2 text-right font-mono-code text-sm">{(e.badges || []).length}</div>
                <div className="col-span-2 text-right font-serif-display text-lg">{e.xp}</div>
              </div>
            );
          })
        )}
      </div>

      <div className="mt-6 text-xs text-muted-foreground font-mono-code">
        your xp · {progress.xp || 0} · session · {sessionId.slice(0, 14)}…
      </div>
    </div>
  );
}
